const rankingItems = [
  { rank: 1, title: '顶流小生恋情实锤：深夜同回公寓视频曝光', heat: '1280万', change: 'up' as const, tag: '新晋' },
  { rank: 2, title: '某选秀节目黑幕：导演组内部评分表流出', heat: '1150万', change: 'up' as const, tag: '热议' },
  { rank: 3, title: '知名企业家涉嫌财务造假，证监会立案调查', heat: '1020万', change: 'up' as const, tag: '热点' },
  { rank: 4, title: '网红夫妻离婚互撕，双方各自放出对方出轨证据', heat: '960万', change: 'down' as const, tag: '' },
  { rank: 5, title: '某古装剧男主被扒学历造假，剧组紧急发声明', heat: '890万', change: 'up' as const, tag: '' },
  { rank: 6, title: '电竞圈年度最大瓜：冠军战队内部矛盾全面爆发', heat: '830万', change: 'down' as const, tag: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜热度榜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">实时更新的热门吃瓜事件排行，热度即正义</p>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 transition-colors duration-200 hover:bg-accent-50/50 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-accent-400 text-white' :
                item.rank === 3 ? 'bg-secondary-400 text-white' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
              </div>

              {item.tag && (
                <span className="hidden sm:inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                  {item.tag}
                </span>
              )}

              <div className="flex items-center gap-1.5 text-xs whitespace-nowrap">
                {item.change === 'up' ? (
                  <i className="ri-arrow-up-line text-accent-500"></i>
                ) : (
                  <i className="ri-arrow-down-line text-foreground-500"></i>
                )}
                <span className="text-foreground-600 font-medium">{item.heat}</span>
              </div>

              <span className="text-foreground-400">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}